angular.module('aprima-core-ui').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/core-ui/component-views/ap-caching-settings.html',
    "<div class=\"form-group\">\r" +
    "\n" +
    "    <div class=\"form-control-static\">\r" +
    "\n" +
    "        Size: {{vm.totalSize()}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <button class=\"btn btn-primary\"\r" +
    "\n" +
    "            hm-click=\"vm.clearAll()\"\r" +
    "\n" +
    "            translate>\r" +
    "\n" +
    "        Clear Cache\r" +
    "\n" +
    "    </button>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-details.html',
    "<ap-erx-request-medication\r" +
    "\n" +
    "        label=\"'Refill Requested - Medication Prescribed'\"\r" +
    "\n" +
    "        requested-med=\"vm.refillRequest.PrescribedMedication\"\r" +
    "\n" +
    "        current-prescription=\"vm.prescription\">\r" +
    "\n" +
    "</ap-erx-request-medication>\r" +
    "\n" +
    "<ap-erx-request-medication\r" +
    "\n" +
    "        label=\"'Refill Requested - Medication Dispensed'\"\r" +
    "\n" +
    "        requested-med=\"vm.refillRequest.DispensedMedication\">\r" +
    "\n" +
    "</ap-erx-request-medication>\r" +
    "\n" +
    "<ap-erx-request-patient\r" +
    "\n" +
    "        requested-patient=\"vm.refillRequest\"\r" +
    "\n" +
    "        current-patient=\"vm.patient\">\r" +
    "\n" +
    "</ap-erx-request-patient>\r" +
    "\n" +
    "<ap-erx-request-provider\r" +
    "\n" +
    "        label=\"'Prescriber'\"\r" +
    "\n" +
    "        requested-provider=\"vm.refillRequest\">\r" +
    "\n" +
    "</ap-erx-request-provider>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-dual-row.html',
    "<div class=\"flex-table-col-group\" ng-if=\"vm.firstValue || vm.header()\"\r" +
    "\n" +
    "     ng-class=\"{'flex-table-shaded': vm.header()}\">\r" +
    "\n" +
    "    <div class=\"erx-fixed-label\"\r" +
    "\n" +
    "        ng-class=\"vm.header() ? 'erx-header-label' : 'erx-field-label'\">\r" +
    "\n" +
    "        {{::vm.label}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"flex-equal\"\r" +
    "\n" +
    "         ng-class=\"{'erx-header-label': vm.header()}\">\r" +
    "\n" +
    "        {{vm.firstText || vm.firstValue}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"flex-equal\"\r" +
    "\n" +
    "         ng-class=\"{'alert-warning': vm.warn() && vm.hasWarning(),\r" +
    "\n" +
    "                    'erx-header-label': vm.header(),\r" +
    "\n" +
    "                    'flex-table-disabled': !vm.header() && !vm.hasOwnProperty('secondText') && !vm.hasOwnProperty('secondValue')}\">\r" +
    "\n" +
    "        {{vm.secondText || vm.secondValue}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-full-row.html',
    "<div class=\"flex-table-col-group\"\r" +
    "\n" +
    "     ng-if=\"vm.value\"\r" +
    "\n" +
    "     ng-class=\"{'flex-table-shaded': vm.header()}\">\r" +
    "\n" +
    "    <div class=\"erx-fixed-label erx-field-label\" ng-if=\"!vm.header()\">{{::vm.label}}</div>\r" +
    "\n" +
    "    <div class=\"flex-auto\"\r" +
    "\n" +
    "         ng-class=\"{'erx-header-label': vm.header()}\"\r" +
    "\n" +
    "         ng-transclude>\r" +
    "\n" +
    "        {{vm.value}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-medication.html',
    "<div class=\"panel panel-default panel-flush\" ng-if=\"vm.requestedMed\">\r" +
    "\n" +
    "    <div class=\"panel-heading clickable\"\r" +
    "\n" +
    "         ng-click=\"vm.isOpen = !vm.isOpen\">\r" +
    "\n" +
    "        <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "            <span ng-class=\"vm.isOpen ? 'ap-chevron-up-blue' : 'ap-chevron-down-blue'\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        {{::vm.label}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"flex-table-bordered flex-table-hyphens\" uib-collapse=\"!vm.isOpen\">\r" +
    "\n" +
    "        <div ng-if=\"vm.hasOwnProperty('currentPrescription')\">\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    class=\"flex-table-top\"\r" +
    "\n" +
    "                    label=\"'eRx Med'\"\r" +
    "\n" +
    "                    first-value=\"'eRx Value'\"\r" +
    "\n" +
    "                    second-value=\"'Selected Value'\"\r" +
    "\n" +
    "                    header=\"true\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Description'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.Name\"\r" +
    "\n" +
    "                    first-text=\"vm.medDescriptionText(vm.requestedMed.Name, vm.requestedMed.NDCDescription)\"\r" +
    "\n" +
    "                    second-value=\"vm.currentPrescription.DrugDescription\"\r" +
    "\n" +
    "                    warn=\"true\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'DEA Schedule'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.DEASchedule\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Patient Instructions'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.Sig\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Quantity'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.Quantity\"\r" +
    "\n" +
    "                    first-text=\"vm.requestedMed.QuantityDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.currentPrescription.Instructions[0].TotalQuantity\"\r" +
    "\n" +
    "                    warn=\"true\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Days Supply'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.Duration\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Refills'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.RefillDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.refills(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Pharmacy Notes'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.Comment\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Substitution'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.SubstitutionTerm\"\r" +
    "\n" +
    "                    second-value=\"vm.substitutionText(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Strength'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.StrengthDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.strengthText(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Product Code'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.ProductCodeDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.productCodeText(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Drug DB Code'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.DrugDBCodeDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.drugDbCodeText(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "            <ap-erx-request-dual-row\r" +
    "\n" +
    "                    label=\"'Form Code'\"\r" +
    "\n" +
    "                    first-value=\"vm.requestedMed.FormDescription\"\r" +
    "\n" +
    "                    second-value=\"vm.drugFormText(vm.currentPrescription)\">\r" +
    "\n" +
    "            </ap-erx-request-dual-row>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!vm.hasOwnProperty('currentPrescription')\">\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    class=\"flex-table-top\"\r" +
    "\n" +
    "                    value=\"'eRx Med'\"\r" +
    "\n" +
    "                    header=\"true\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Description'\"\r" +
    "\n" +
    "                    value=\"vm.medDescriptionText(vm.requestedMed.Name, vm.requestedMed.NDCDescription)\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'DEA Schedule'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.DEASchedule\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Patient Instructions'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.Sig\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Quantity'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.QuantityDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Days Supply'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.Duration\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Refills'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.RefillDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Pharmacy Notes'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.Comment\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Substitution'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.SubstitutionTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Strength'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.StrengthDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Product Code'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.ProductCodeDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Drug DB Code'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.DrugDBCodeDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Form Code'\"\r" +
    "\n" +
    "                    value=\"vm.requestedMed.FormDescription\"/>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                ng-if=\"vm.hasDetails()\"\r" +
    "\n" +
    "                value=\"'eRx Request Details'\"\r" +
    "\n" +
    "                header=\"true\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Written Date'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.WrittenDate\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.WrittenDate}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Last Fill Date'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.LastFillDate\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.LastFillDate}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Expiration Date'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.ExpirationDate\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.ExpirationDate}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Effective Date'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.EffectiveDate\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.EffectiveDate}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Period End'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.PeriodEnd\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.PeriodEnd}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Date Validated'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.DateValidated\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.DateValidated}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Sold Date'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.SoldDate\">\r" +
    "\n" +
    "            <ap-date-formatter date=\"{{vm.requestedMed.SoldDate}}\" format=\"date\"></ap-date-formatter>\r" +
    "\n" +
    "        </ap-erx-request-full-row>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Prior Authorization'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.PriorAuthorizationDescription\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Prior Authorization Status'\"\r" +
    "\n" +
    "                value=\"vm.requestedMed.PriorAuthorizationStatusTerm\"/>\r" +
    "\n" +
    "        <div ng-repeat=\"diagnosis in vm.requestedMed.Diagnoses track by $index\">\r" +
    "\n" +
    "            <!--use / at end instead of closing tag, so that there is no transcluded content-->\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    value=\"'Diagnosis ' + ($index + 1)\"\r" +
    "\n" +
    "                    header=\"true\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Primary'\"\r" +
    "\n" +
    "                    value=\"diagnosis.PrimaryDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Secondary'\"\r" +
    "\n" +
    "                    value=\"diagnosis.SecondaryDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Clinical Info'\"\r" +
    "\n" +
    "                    value=\"diagnosis.ClinicalInformationQualifierTerm\"/>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-repeat=\"drugUseEval in vm.requestedMed.DrugUseEvaluations track by $index\">\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    value=\"'Drug Use Evaluation ' + ($index + 1)\"\r" +
    "\n" +
    "                    header=\"true\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Service Reason'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.ServiceReasonTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Professional Service'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.ProfessionalServiceTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Service Result'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.ServiceResultTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'CoAgent'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.CoAgentDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Clinical Significance'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.ClinicalSignificanceTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Acknowledgement Reason'\"\r" +
    "\n" +
    "                    value=\"drugUseEval.AcknowledgementReason\"/>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                ng-if=\"vm.requestedMed.DrugCoverageStatuses.length\"\r" +
    "\n" +
    "                value=\"'Drug Coverage Status'\"\r" +
    "\n" +
    "                header=\"true\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                ng-repeat=\"drugCoverageStatus in vm.requestedMed.DrugCoverageStatuses track by $index\"\r" +
    "\n" +
    "                label=\"'Status'\"\r" +
    "\n" +
    "                value=\"drugCoverageStatus\"/>\r" +
    "\n" +
    "        <div ng-repeat=\"sig in vm.requestedMed.StructuredSigs track by $index\">\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    value=\"'Structured SIG ' + ($index + 1)\"\r" +
    "\n" +
    "                    header=\"true\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Sequence'\"\r" +
    "\n" +
    "                    value=\"sig.RepeatingSigSequenceDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Free Text'\"\r" +
    "\n" +
    "                    value=\"sig.SigFreeText\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Dose Composite Indicator'\"\r" +
    "\n" +
    "                    value=\"sig.DoseCompositeIndicatorTerm\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Dose Delivery Method'\"\r" +
    "\n" +
    "                    value=\"sig.DoseDeliveryMethodDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Dose Delivery Modifier'\"\r" +
    "\n" +
    "                    value=\"sig.DoseDeliveryMethodModifierDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Dose'\"\r" +
    "\n" +
    "                    value=\"sig.DoseQuantityDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Dosing Basis'\"\r" +
    "\n" +
    "                    value=\"sig.DosingBasisDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Body Metric'\"\r" +
    "\n" +
    "                    value=\"sig.BodyMetricDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Calculated Dose'\"\r" +
    "\n" +
    "                    value=\"sig.CalculatedDoseDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Vehicle'\"\r" +
    "\n" +
    "                    value=\"sig.VehicleNameDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Vehicle Quantity'\"\r" +
    "\n" +
    "                    value=\"sig.VehicleQuantityDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Route of Administration'\"\r" +
    "\n" +
    "                    value=\"sig.RouteofAdministrationDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Site of Administration'\"\r" +
    "\n" +
    "                    value=\"sig.SiteofAdministrationDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Administration Timing'\"\r" +
    "\n" +
    "                    value=\"sig.AdministrationTimingDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Rate of Administration'\"\r" +
    "\n" +
    "                    value=\"sig.RateOfAdministrationDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Timing Basis'\"\r" +
    "\n" +
    "                    value=\"sig.TimePeriodBasisDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Frequency'\"\r" +
    "\n" +
    "                    value=\"sig.FrequencyDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Interval'\"\r" +
    "\n" +
    "                    value=\"sig.IntervalDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Duration'\"\r" +
    "\n" +
    "                    value=\"sig.DurationDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Maximum Dose'\"\r" +
    "\n" +
    "                    value=\"sig.MaximumDoseDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Maximum Dose Variable'\"\r" +
    "\n" +
    "                    value=\"sig.MaximumDoseVariableDescription\"/>\r" +
    "\n" +
    "            <ap-erx-request-full-row\r" +
    "\n" +
    "                    label=\"'Stop Indicator'\"\r" +
    "\n" +
    "                    value=\"sig.StopIndicatorTerm\"/>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-patient.html',
    "<div class=\"panel panel-default panel-flush\" ng-if=\"vm.requestedPatient\">\r" +
    "\n" +
    "    <div class=\"panel-heading clickable\"\r" +
    "\n" +
    "         ng-click=\"vm.isOpen = !vm.isOpen\">\r" +
    "\n" +
    "        <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "            <span ng-class=\"vm.isOpen ? 'ap-chevron-up-blue' : 'ap-chevron-down-blue'\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        Patient\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"flex-table-bordered flex-table-hyphens\" uib-collapse=\"!vm.isOpen\">\r" +
    "\n" +
    "        <ap-erx-request-dual-row\r" +
    "\n" +
    "                class=\"flex-table-top\"\r" +
    "\n" +
    "                label=\"'eRx Patient'\"\r" +
    "\n" +
    "                first-value=\"'eRx Value'\"\r" +
    "\n" +
    "                second-value=\"'Selected Value'\"\r" +
    "\n" +
    "                header=\"true\">\r" +
    "\n" +
    "        </ap-erx-request-dual-row>\r" +
    "\n" +
    "        <ap-erx-request-dual-row\r" +
    "\n" +
    "                label=\"'Name'\"\r" +
    "\n" +
    "                first-value=\"vm.requestedPatient.PatientLastName + ',' + vm.requestedPatient.PatientFirstName\"\r" +
    "\n" +
    "                first-text=\"vm.requestedPatient.PatientFullName\"\r" +
    "\n" +
    "                second-value=\"vm.currentPatient.LastName + ',' + vm.currentPatient.FirstName\"\r" +
    "\n" +
    "                second-text=\"vm.currentPatient.Name\"\r" +
    "\n" +
    "                warn=\"true\">\r" +
    "\n" +
    "        </ap-erx-request-dual-row>\r" +
    "\n" +
    "        <ap-erx-request-dual-row\r" +
    "\n" +
    "                label=\"'Date of Birth'\"\r" +
    "\n" +
    "                first-value=\"vm.requestedPatient.PatientDob\"\r" +
    "\n" +
    "                second-value=\"vm.currentPatient.BirthDate\">\r" +
    "\n" +
    "        </ap-erx-request-dual-row>\r" +
    "\n" +
    "        <ap-erx-request-dual-row\r" +
    "\n" +
    "                label=\"'Address'\"\r" +
    "\n" +
    "                first-value=\"vm.requestedPatient.PatientAddress + ', ' + vm.requestedPatient.PatientCityStateZip\">\r" +
    "\n" +
    "        </ap-erx-request-dual-row>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-erx-request-provider.html',
    "<div class=\"panel panel-default panel-flush\" ng-if=\"vm.requestedProvider\">\r" +
    "\n" +
    "    <div class=\"panel-heading clickable\"\r" +
    "\n" +
    "         ng-click=\"vm.isOpen = !vm.isOpen\">\r" +
    "\n" +
    "        <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "            <span ng-class=\"vm.isOpen ? 'ap-chevron-up-blue' : 'ap-chevron-down-blue'\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        {{::vm.label}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"flex-table-bordered flex-table-hyphens\" uib-collapse=\"!vm.isOpen\">\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                class=\"flex-table-top\"\r" +
    "\n" +
    "                value=\"'eRx Provider'\"\r" +
    "\n" +
    "                header=\"true\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Name'\"\r" +
    "\n" +
    "                value=\"vm.requestedProvider.PhysicianFullName\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Address'\"\r" +
    "\n" +
    "                value=\"vm.requestedProvider.PhysicianAddress + ', ' + vm.requestedProvider.PhysicianCityStateZip\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Identification'\"\r" +
    "\n" +
    "                value=\"vm.identification(vm.requestedProvider)\"/>\r" +
    "\n" +
    "        <ap-erx-request-full-row\r" +
    "\n" +
    "                label=\"'Phone'\"\r" +
    "\n" +
    "                value=\"vm.PhysicianPhone\"/>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-multi-select-button.html',
    "<button class=\"btn btn-default btn-input-form-control overflow-ellipsis\"\r" +
    "\n" +
    "        type=\"button\"\r" +
    "\n" +
    "        ng-click=\"vm.onClick()\"\r" +
    "\n" +
    "        ng-disabled=\"vm.ngDisabled()\">\r" +
    "\n" +
    "    <span class=\"ap-plus-blue pull-right\"></span>\r" +
    "\n" +
    "    <span>\r" +
    "\n" +
    "        {{vm.innerValue}}\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</button>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/ap-multi-select-fa-button.html',
    "<button class=\"btn btn-default btn-input-form-control overflow-ellipsis\"\r" +
    "\n" +
    "        type=\"button\"\r" +
    "\n" +
    "        ng-click=\"vm.onClick()\"\r" +
    "\n" +
    "        ng-disabled=\"vm.ngDisabled()\">\r" +
    "\n" +
    "    <span class=\"fa fa-plus pull-right\"></span>\r" +
    "\n" +
    "    <span>\r" +
    "\n" +
    "        {{vm.innerValue}}\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</button>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/core-ui/component-views/apDocumentViewWithDownload.html',
    "\r" +
    "\n" +
    "<div>\r" +
    "\n" +
    "    <ap-document-viewer \r" +
    "\n" +
    "        disable-fullscreen=\"$ctrl.disableFullscreen\"\r" +
    "\n" +
    "        disable-inline-pdf=\"$ctrl.disableInlinePdf\"\r" +
    "\n" +
    "        load-function=\"$ctrl.onDocumentLoad(documentId, requestSettings)\" \r" +
    "\n" +
    "        document-id=\"$ctrl.documentId\"\r" +
    "\n" +
    "    ></ap-document-viewer>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"text-center\" ng-show=\"$ctrl.canOpenInSeparateTab() && !$ctrl.loadingDocument\">\r" +
    "\n" +
    "    <span>{{'Click ' | translate}}<a ng-click=\"$ctrl.onDocumentOpenInSeparateTab($ctrl.documentId)\">{{'here' | translate}}</a>{{' to view in a separate tab.' | translate}}</span>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"text-center\" ng-show=\"$ctrl.canDownloadDocument() && !$ctrl.loadingDocument\">\r" +
    "\n" +
    "        <span ng-hide=\"$ctrl.downloadingDocument\">{{'Download ' | translate}}<a\r" +
    "\n" +
    "                ap-save-to-file=\"$ctrl.onDocumentDownload($ctrl.documentId)\"\r" +
    "\n" +
    "                file-name=\"{{$ctrl.downloadFileName}}\"\r" +
    "\n" +
    "                >{{'here.' | translate}}</a></span>\r" +
    "\n" +
    "        <ap-spinner ng-show=\"$ctrl.downloadingDocument\"></ap-spinner>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/component-views/tinymce.html',
    "<textarea\r" +
    "\n" +
    "    ui-tinymce=\"$ctrl.tinymceOptions\"\r" +
    "\n" +
    "    ng-model=\"$ctrl.value\"\r" +
    "\n" +
    "    ng-model-options=\"$ctrl.tinymceModelOptions\"\r" +
    "\n" +
    "    ng-change=\"$ctrl.onChange()\"\r" +
    "\n" +
    "></textarea>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/modal-views/generalNotesModal.html',
    "<div ap-full-modal ap-full-modal-always class=\"modal-v18 modal-general-notes\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-8 heading-title modal-title\">\r" +
    "\n" +
    "                {{vm.title}}\r" +
    "\n" +
    "                <ap-spinner ng-show=\"vm.initialLoading\" class=\"ng-hide\" size=\"1\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <button id=\"gnm-close-x\" type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div class=\"row row-full\">\r" +
    "\n" +
    "            <div class=\"col-xs-3\" id=\"search-section\" ng-if=\"::vm.generalNotesSupported\">\r" +
    "\n" +
    "                <div class=\"search-section-content\">\r" +
    "\n" +
    "                    <div class= \"form-group\">\r" +
    "\n" +
    "                        <label for=\"searchInput\">Search</label>\r" +
    "\n" +
    "                        <input type=\"text\" id=\"searchInput\" ng-model=\"vm.searchText\" class=\"form-control\" ng-change=\"vm.changeSearchCriteria()\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{'General Note Type' | translate}}</label>\r" +
    "\n" +
    "                        <ap-select>\r" +
    "\n" +
    "                            <select class=\"form-control\"\r" +
    "\n" +
    "                                    name=\"GeneralNoteTypeId\"\r" +
    "\n" +
    "                                    ng-model=\"vm.searchGeneralNoteType\"\r" +
    "\n" +
    "                                    ng-options=\"entry.Name for entry in vm.generalNoteTypeList track by entry.Id\"\r" +
    "\n" +
    "                                    ng-change=\"vm.changeSearchCriteria()\"\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                            </select>\r" +
    "\n" +
    "                        </ap-select>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        <input type=\"checkbox\"\r" +
    "\n" +
    "                                id=\"generalNoteIncludeInactive\"\r" +
    "\n" +
    "                                ng-model=\"vm.includeInactive\"\r" +
    "\n" +
    "                                ng-change=\"vm.changeSearchCriteria()\">\r" +
    "\n" +
    "                        <label for=\"generalNoteIncludeInactive\">{{'Include Inactive' | translate}}</label>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"search-section-results\">\r" +
    "\n" +
    "                    <div class=\"spinner-container text-center\" ng-if=\"vm.loadingSearch\">\r" +
    "\n" +
    "                        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-repeat=\"entry in vm.generalNoteList track by entry.Id\" ng-if=\"!vm.loadingSearch\">\r" +
    "\n" +
    "                        <div class=\"list-group-item\">\r" +
    "\n" +
    "                            <div class=\"list-item-heading overflow-ellipsis\"\r" +
    "\n" +
    "                                 ng-click=\"vm.appendNote(entry)\" id=\"gnm-result-{{$index}}\">\r" +
    "\n" +
    "                                <span class=\"pull-right\"><i class=\"ap-chevron-right-gray\"></i></span>\r" +
    "\n" +
    "                                {{::entry.Name}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div id=\"tinymce-section\" ng-class=\"::vm.generalNotesSupported ? 'col-xs-9 col-flush-left' : 'col-xs-12'\">\r" +
    "\n" +
    "                <div class=\"modal-text\" ng-if=\"vm.disableFormatting && !!vm.maxCharacters\">\r" +
    "\n" +
    "                    ({{vm.getRemainingCharacters()}} {{'of' | translate}} {{vm.maxCharacters}})\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <tinymce\r" +
    "\n" +
    "                    id=\"gnm-tinymce\"\r" +
    "\n" +
    "                    ng-if=\"!vm.disableFormatting\"\r" +
    "\n" +
    "                    height='vm.tinymceHeight'\r" +
    "\n" +
    "                    use-advanced-toolbar=\"vm.useAdvancedToolbar\"\r" +
    "\n" +
    "                    value=\"vm.currentNote\"\r" +
    "\n" +
    "                />\r" +
    "\n" +
    "                <textarea\r" +
    "\n" +
    "                    id=\"gnm-textarea\" \r" +
    "\n" +
    "                    ng-if=\"vm.disableFormatting\" \r" +
    "\n" +
    "                    ng-class=\"!!vm.maxCharacters ? 'textarea-full display-char' : 'textarea-full'\" \r" +
    "\n" +
    "                    ng-model=\"vm.currentNote\"\r" +
    "\n" +
    "                    maxlength=\"{{vm.maxCharacters}}\">\r" +
    "\n" +
    "                </textarea>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer modal-footer-multi-button\" ng-class=\"vm.shouldSwapButtons() ? 'prm-button-order' : ''\">\r" +
    "\n" +
    "        <button id=\"gnm-cancel\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\">{{'Cancel' | translate}}</button>\r" +
    "\n" +
    "        <button id=\"gnm-ok\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\">{{'OK' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/modal-views/multi-select-list-item-modal.html',
    "<div class=\"modal-noborder\" ap-full-modal>\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        {{::'Select All That Apply:' | translate}} ({{vm.countSelected()}})\r" +
    "\n" +
    "        <button type=\"button\"\r" +
    "\n" +
    "                class=\"close\"\r" +
    "\n" +
    "                ng-click=\"vm.cancel()\">\r" +
    "\n" +
    "            &times;\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"!vm.httpError\">\r" +
    "\n" +
    "            <div ng-repeat=\"item in vm.items | orderBy: vm.getItemOrder track by item.Id\">\r" +
    "\n" +
    "                <input type=\"checkbox\"\r" +
    "\n" +
    "                       ap-checkbox-label=\"{{vm.formatter(item)}}\"\r" +
    "\n" +
    "                       id=\"select-item-{{$index}}\"\r" +
    "\n" +
    "                       ng-model=\"item.selected\">\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer modal-footer-multi-button\">\r" +
    "\n" +
    "        <button type=\"button\"\r" +
    "\n" +
    "                class=\"btn btn-default\"\r" +
    "\n" +
    "                ng-click=\"vm.clear()\">\r" +
    "\n" +
    "            {{::'Clear' | translate}}\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "        <button type=\"button\"\r" +
    "\n" +
    "                class=\"btn btn-default\"\r" +
    "\n" +
    "                ng-click=\"vm.load(true)\">\r" +
    "\n" +
    "            {{::'Refresh List' | translate}}\r" +
    "\n" +
    "            <i class=\"fa fa-refresh\"/>\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "        <button type=\"button\"\r" +
    "\n" +
    "                class=\"btn btn-primary\"\r" +
    "\n" +
    "                ng-click=\"vm.done()\"\r" +
    "\n" +
    "                translate>\r" +
    "\n" +
    "            {{::'Done' | translate}}\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/confirm.html',
    "<div id=\"ap-confirm\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">×</button>\r" +
    "\n" +
    "        <h4 class=\"modal-title\" ng-bind-html=\"vm.message\"></h4>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <div class=\"flex-table-col-group\">\r" +
    "\n" +
    "            <div class=\"flex-equal\">\r" +
    "\n" +
    "                <button id=\"ok-button\" class=\"btn btn-primary btn-block keep-whitespace-line btn-full-height\" type=\"button\" ng-click=\"vm.close(true)\">{{vm.okText}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"flex-equal\">\r" +
    "\n" +
    "                <button id=\"cancel-button\" class=\"btn btn-default btn-block keep-whitespace-line btn-full-height\" type=\"button\" ng-click=\"vm.close(false)\">{{vm.cancelText}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apAddress.html',
    "<address ng-if=\"address\">\r" +
    "\n" +
    "    <a ng-click=\"openMap()\">\r" +
    "\n" +
    "        {{::address.Address1}}\r" +
    "\n" +
    "        <br/>\r" +
    "\n" +
    "        {{::address.Address2}}\r" +
    "\n" +
    "        <br ng-if=\"address.Address2\"/>\r" +
    "\n" +
    "        {{::address.City}}<span ng-if=\"address.City && (address.State || address.Zip)\">,</span> {{::address.State}} {{::address.Zip}}\r" +
    "\n" +
    "        {{::address.Country}}\r" +
    "\n" +
    "    </a>\r" +
    "\n" +
    "</address>"
  );


  $templateCache.put('/core-ui/views/directives/apAppointmentContextMenu.html',
    "<div class=\"context-menu\" id=\"appt-context-menu\" ng-cloak>\r" +
    "\n" +
    "    <ul class=\"dropdown-menu position-fixed\" role=\"menu\">\r" +
    "\n" +
    "        <li class=\"dropdown-header\">\r" +
    "\n" +
    "            <span translate>Actions</span>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"appointment.PatientId\">\r" +
    "\n" +
    "            <a class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"1\"\r" +
    "\n" +
    "               data-transition-to=\"{ appRoute: 'patientDashboard', opts: {id: appointment.PatientId, appointmentId: appointment.Id}}\" translate>\r" +
    "\n" +
    "                View Patient Dashboard\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li>\r" +
    "\n" +
    "            <a class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"2\"\r" +
    "\n" +
    "               data-ap-transition-to-appointment\r" +
    "\n" +
    "               data-appt-schedule-type=\"{{appointment.ScheduleType}}\"\r" +
    "\n" +
    "               data-appt-id=\"{{appointment.Id}}\"\r" +
    "\n" +
    "               translate>\r" +
    "\n" +
    "                View Appointment\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"schedulePermissionAllowed\">\r" +
    "\n" +
    "            <a class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"3\"\r" +
    "\n" +
    "               data-ap-transition-to-appointment\r" +
    "\n" +
    "               data-appt-schedule-type=\"{{appointment.ScheduleType}}\"\r" +
    "\n" +
    "               data-appt-id=\"{{appointment.Id}}\"\r" +
    "\n" +
    "               data-appt-edit=\"true\"\r" +
    "\n" +
    "               translate>\r" +
    "\n" +
    "                Edit Appointment\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"schedulePermissionAllowed\">\r" +
    "\n" +
    "            <a class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"4\"\r" +
    "\n" +
    "               data-ap-transition-to-appointment\r" +
    "\n" +
    "               data-appt-schedule-type=\"{{appointment.ScheduleType}}\"\r" +
    "\n" +
    "               data-patient-id=\"{{appointment.PatientId}}\"\r" +
    "\n" +
    "               data-calendar-id=\"{{appointment.Calendar.Id}}\"\r" +
    "\n" +
    "               translate>\r" +
    "\n" +
    "                Add Appointment\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"appointment.PatientId\">\r" +
    "\n" +
    "            <a class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"6\"\r" +
    "\n" +
    "               name=\"start-charge-capture\"\r" +
    "\n" +
    "               data-transition-to=\"getChargeCaptureTransition\"\r" +
    "\n" +
    "               ap-authorization provider-required=\"true\"\r" +
    "\n" +
    "               translate>\r" +
    "\n" +
    "                Start eMDs Rounds\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "    </ul>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apDashboardTileHeader.html',
    "<div class=\"panel-heading clickable\"\r" +
    "\n" +
    "     ng-click=\"toggle()\"\r" +
    "\n" +
    "     hm-propagation=\"true\"\r" +
    "\n" +
    "     ng-transclude>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"panel-heading panel-header-sticky clickable\"\r" +
    "\n" +
    "     ng-click=\"toggle()\"\r" +
    "\n" +
    "     hm-propagation=\"true\"\r" +
    "\n" +
    "     ng-transclude>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apDataGroup.html',
    "<div class=\"col-xs-6 col-md-3 col-lg-2\"\r" +
    "\n" +
    "     ng-class=\"normal === 'false' ? 'text-danger' : ''\">\r" +
    "\n" +
    "    <span class=\"ap-label\">\r" +
    "\n" +
    "        {{label}}&nbsp;\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <br/>\r" +
    "\n" +
    "    <span class=\"ap-value\">\r" +
    "\n" +
    "        {{value}}&nbsp;\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apDateRangeFormatter.html',
    "<span ng-if=\"!multiline\">\r" +
    "\n" +
    "    <span class=\"start-date\" ap-date-formatter data-jsdate=\"startDate\" data-format=\"{{format}}\"></span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-if=\"endDate\">\r" +
    "\n" +
    "        <span translate>to</span>\r" +
    "\n" +
    "        <span ap-date-formatter class=\"end-date\" data-jsdate=\"endDate\" data-format=\"{{format}}\"></span>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<!-- white space and new lines intentional and necessary! DO NOT REFORMAT THIS! -->\r" +
    "\n" +
    "<!-- if you have a better way to horizontally and vertically align text, feel free to refactor this.\r" +
    "\n" +
    " white-space: pre is the magic sauce-->\r" +
    "\n" +
    "<span ng-if=\"multiline\" style=\"white-space: pre;\"><span ap-date-formatter class=\"start-date\" data-jsdate=\"startDate\" data-format=\"{{format}}\"></span><span ng-if=\"endDate\">\r" +
    "\n" +
    "<span translate>to</span>\r" +
    "\n" +
    "<span ap-date-formatter class=\"end-date\" data-jsdate=\"endDate\" data-format=\"{{format}}\"></span></span></span>"
  );


  $templateCache.put('/core-ui/views/directives/apDocumentViewer.html',
    "<div class=\"attachment-viewer\">\r" +
    "\n" +
    "    <div ng-if=\"isImage\"\r" +
    "\n" +
    "         name=\"attachment-viewer-image\">\r" +
    "\n" +
    "        <ap-image-viewer\r" +
    "\n" +
    "            current-page=\"pageDetails.currentPage\"\r" +
    "\n" +
    "            disable-fullscreen=\"disableFullscreen\"\r" +
    "\n" +
    "            image-data=\"attachment.imageData\"\r" +
    "\n" +
    "            page-count=\"attachment.PageCount\"\r" +
    "\n" +
    "            load-page=\"loadPage(page)\"\r" +
    "\n" +
    "        ></ap-image-viewer>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"isText\"\r" +
    "\n" +
    "         name=\"attachment-viewer-text\">\r" +
    "\n" +
    "        {{attachment.textData}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"isHtml\"\r" +
    "\n" +
    "         name=\"attachment-viewer-html\">\r" +
    "\n" +
    "        <!-- tried to dynamically set the height of the frame using http://stackoverflow.com/questions/25880671/how-to-set-the-iframe-content-height-in-my-case\r" +
    "\n" +
    "          This did not work because this page is loaded over http:// and the iframe is loaded with data: and browsers do not allow you to access\r" +
    "\n" +
    "          the contents of iframes when the protocols don't match. -->\r" +
    "\n" +
    "        <iframe ng-src=\"{{attachment.htmlData}}\"\r" +
    "\n" +
    "                width=\"100%\"\r" +
    "\n" +
    "                height=\"800\">\r" +
    "\n" +
    "        </iframe>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"isPdf\"\r" +
    "\n" +
    "         name=\"attachment-viewer-pdf\">\r" +
    "\n" +
    "        <p ng-if=\"disableInlinePdf\" class=\"text-center\">{{::'This browser is unable to display the document inside of this webpage.' | translate}}</p>\r" +
    "\n" +
    "        <ap-pdf ng-if=\"!disableInlinePdf\" src=\"attachment.pdfData\"></ap-pdf>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-show=\"!isPdf && !isHtml && !isText && !isImage && !loadingAttachment && !loadError\"\r" +
    "\n" +
    "         name=\"attachment-viewer-unsupported\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <span ng-show=\"attachment.Extension\" class=\"warning\">{{::'Attachment type is not supported' | translate}} ({{attachment.Extension}}).</span>\r" +
    "\n" +
    "        <span ng-show=\"!attachment.Extension\" class=\"warning\">{{::'Attachment type is not known and cannot be displayed.' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-show=\"loadingAttachment && !isImage\" class=\"col-xs-12 text-center\">\r" +
    "\n" +
    "        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-show=\"loadError\"\r" +
    "\n" +
    "         name=\"attachment-viewer-error\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\">\r" +
    "\n" +
    "            {{::\"An error has occurred and the document could not be loaded.\" | translate}}\r" +
    "\n" +
    "            <br />\r" +
    "\n" +
    "            {{::\"Please download the document to view it.\" | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apIcdCodeModal.html',
    "<div id=\"icd-10-search-modal\" ap-full-modal>\r" +
    "\n" +
    "	<div class=\"modal-header\">\r" +
    "\n" +
    "		<button type=\"button\" class=\"close\" hm-click=\"$dismiss('editing')\">&times;</button><div class=\"modal-title\"><button class=\"btn btn-primary btn-nofill btn-xs vertical-centered btn-inverse\" ng-disabled=\"topLevel\" ng-hide=\"codeType === 'ICD9'\" hm-click=\"searchLevelUp();\"><i class=\"fa fa-arrow-up\"></i></button>  {{displayCode}} Codes </div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "	<div class=\"modal-body\">\r" +
    "\n" +
    "		<div class=\"modal-container\">\r" +
    "\n" +
    "			<div class=\"ng-hide\" ng-show=\"!loading\">\r" +
    "\n" +
    "				<h4 class=\"text-center\" style=\"margin-bottom: 5px;\">Modifiers</h4>\r" +
    "\n" +
    "				<div class=\"text-center swipe-indicator\" ng-hide=\"modifierCategories.length <= 1\">\r" +
    "\n" +
    "					<i ng-repeat=\"category in modifierCategories track by $index\"\r" +
    "\n" +
    "                       class=\"fa\"\r" +
    "\n" +
    "					   ng-class=\"modifierIndex === $index ? 'fa-circle' : 'fa-circle-o'\"/>\r" +
    "\n" +
    "				</div>\r" +
    "\n" +
    "				<ap-swipeable scroll-div=\".modal-body\" auto-resize=\"true\" current-pane=\"modifierIndex\" class=\"autoscaling-swipe-container\" ng-hide=\"modifierCategories.length == 0\">\r" +
    "\n" +
    "					<div class=\"panel panel-default panel-bordered\" ng-repeat=\"category in modifierCategories track by $index\" id=\"modifier-panel-{{$index}}\">\r" +
    "\n" +
    "						<div class=\"panel-heading\">\r" +
    "\n" +
    "							<h3 class=\"panel-title text-center\">\r" +
    "\n" +
    "								{{ category.Description }}\r" +
    "\n" +
    "							</h3>\r" +
    "\n" +
    "						</div>\r" +
    "\n" +
    "						<ul class=\"list-group\">\r" +
    "\n" +
    "							<li class=\"list-group-item\" ng-repeat=\"modifier in category.Modifiers\" \r" +
    "\n" +
    "								ng-class=\"{'selected' : modifier.isSelected, 'disabled' : modifier.disabled}\"\r" +
    "\n" +
    "								ng-disabled=\"modifier.disabled\" hm-click=\"modifierSelected(modifier)\">\r" +
    "\n" +
    "								<div>{{modifier.Description}}</div>\r" +
    "\n" +
    "							</li>\r" +
    "\n" +
    "						</ul>\r" +
    "\n" +
    "					</div>\r" +
    "\n" +
    "				</ap-swipeable>\r" +
    "\n" +
    "				<h4 class=\"text-center\">Codes ({{filteredCodes.length}})</h4>\r" +
    "\n" +
    "				<ul class=\"list-group\">\r" +
    "\n" +
    "					<li id=\"filtered-dx-code-{{$index}}\" class=\"list-group-item\" ng-repeat=\"diagnosis in filteredCodes\" hm-click=\"diagnosisSelected(diagnosis)\">\r" +
    "\n" +
    "						({{::diagnosis.DiagnosisCode10 || diagnosis.DiagnosisCode9}}) {{::diagnosis.DiagnosisDescription}}\r" +
    "\n" +
    "					</li>\r" +
    "\n" +
    "				</ul>\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "			<div id=\"icd-modal-spinner ng-hide\" ng-show=\"loading\" class=\"spinner-container text-center\">\r" +
    "\n" +
    "				<ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "			<div class=\"col-xs-12 ng-hide\" ng-show=\"httpError\">\r" +
    "\n" +
    "				<uib-alert type=\"danger\">\r" +
    "\n" +
    "					{{::\"An error has occurred and the icd codes could not be loaded.\" | translate}}\r" +
    "\n" +
    "				</uib-alert>\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "		</div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apImageViewer.html',
    "<div class=\"image-viewer\">\r" +
    "\n" +
    "	<div class=\"row image-container\" ng-cloak>\r" +
    "\n" +
    "		<div ng-show=\"!loadingImage\" class=\"image-display-host\">\r" +
    "\n" +
    "			<img class=\"image-display\" ng-src=\"{{imageData}}\" hm-options=\"{preventDefault: true, dragLockToAxis: true, dragBlockHorizontal: true}\" \r" +
    "\n" +
    "				hm-pinch=\"onPinch\" hm-doubletap=\"onTap()\" hm-pinchend=\"onRelease\" hm-panend=\"onRelease\" hm-panmove=\"onDrag\" hm-swipe=\"onSwipe\" />\r" +
    "\n" +
    "            <div ng-show=\"!disableFullscreen\" class=\"fullscreen-overlay\">\r" +
    "\n" +
    "                <i class=\"pull-right fa fa-arrows-alt\" ng-click=\"isFullScreenMode = true;\"></i>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "		</div>\r" +
    "\n" +
    "		<div ng-show=\"loadingImage\" class=\"container image-loading-host\">\r" +
    "\n" +
    "			<ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "		</div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "	<div class=\"text-center image-footer\" ng-show=\"pageCount > 1\">\r" +
    "\n" +
    "		<nav>\r" +
    "\n" +
    "            <uib-pagination total-items=\"pageCount\"\r" +
    "\n" +
    "                      ng-model=\"currentPage\"\r" +
    "\n" +
    "                      max-size=\"4\"\r" +
    "\n" +
    "                      items-per-page=\"1\"\r" +
    "\n" +
    "                      ng-change=\"moveToPage()\"\r" +
    "\n" +
    "                      class=\"pagination-sm image-viewer-paginator\"\r" +
    "\n" +
    "                      boundary-links=\"true\">\r" +
    "\n" +
    "            </uib-pagination>\r" +
    "\n" +
    "		</nav>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "    <div ng-show=\"isFullScreenMode\" class=\"fullscreen-image-viewer ng-hide\">\r" +
    "\n" +
    "        <div class=\"fullscreen-overlay\">\r" +
    "\n" +
    "            <i class=\"pull-right fa fa-times\" ng-click=\"isFullScreenMode = false;\"></i>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <img class=\"fullscreen-image-display\" ng-hide=\"loadingImage\" ng-src=\"{{imageData}}\" hm-options=\"{preventDefault: true, dragLockToAxis: true, dragBlockHorizontal: true}\" \r" +
    "\n" +
    "				hm-pinch=\"onFsPinch\" hm-doubletap=\"onFsTap()\" hm-pinchend=\"onFsRelease\" hm-panend=\"onFsRelease\" hm-panmove=\"onFsDrag\" hm-swipe=\"onFsSwipe\" />\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apLoadingModal.html',
    "<div ap-full-modal ap-full-modal-always>\r" +
    "\n" +
    "	<div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"$emit('modal-cancel');\">&times;</button>\r" +
    "\n" +
    "        <h4 class=\"modal-title\" translate>Loading</h4>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "	<div class=\"modal-body\">\r" +
    "\n" +
    "		<div class=\"col-xs-12 text-center\">\r" +
    "\n" +
    "			<ap-spinner data-size=\"3\"></ap-spinner>\r" +
    "\n" +
    "		</div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apMediaPicker.html',
    "<div>\r" +
    "\n" +
    "    <button class=\"btn btn-default\"\r" +
    "\n" +
    "            type=\"button\"\r" +
    "\n" +
    "            ng-if=\"!image\"\r" +
    "\n" +
    "            ng-click=\"pickImage()\">\r" +
    "\n" +
    "            {{::'Pick Image' | translate}}\r" +
    "\n" +
    "    </button>\r" +
    "\n" +
    "    <img class=\"col-xs-flush clickable img-responsive\"\r" +
    "\n" +
    "         ng-src=\"data:image/jpeg;base64,{{image}}\"\r" +
    "\n" +
    "         ng-if=\"image\"\r" +
    "\n" +
    "         ng-click=\"pickImage()\">\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apMessageAssignTo.html',
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "        <div class=\"detail-group\">\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label class=\"control-label\" translate>Assigned To</label>\r" +
    "\n" +
    "                <ap-select>\r" +
    "\n" +
    "                    <span class=\"input-group-btn\">\r" +
    "\n" +
    "                        <button id=\"reassign-msg-tocreator\"\r" +
    "\n" +
    "                                class=\"btn btn-default\"\r" +
    "\n" +
    "                                type=\"button\"\r" +
    "\n" +
    "                                ng-click=\"reassignHandler()\"\r" +
    "\n" +
    "                                ng-disabled=\"message.Status === 'Complete'\">\r" +
    "\n" +
    "                            <span class=\"fa fa-reply\"></span>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <select ng-disabled=\"message.Status == 'Complete'\" class=\"form-control\"\r" +
    "\n" +
    "                            id=\"userList\"\r" +
    "\n" +
    "                            name=\"userList\"\r" +
    "\n" +
    "                            ng-model=\"userList.Assigned\"\r" +
    "\n" +
    "                            ng-options=\"user.Name for user in users track by user.UserId\"\r" +
    "\n" +
    "                            ng-change=\"clickHandler()\">\r" +
    "\n" +
    "                    </select>\r" +
    "\n" +
    "                </ap-select>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apMessageIcon.html',
    "<span ng-switch=\"iconName\" class=\"message-icon\" title=\"{{iconName}}\">\r" +
    "\n" +
    "    <span ng-switch-when=\"lab-urgent\">\r" +
    "\n" +
    "        <i class=\"ap-message-lab-important\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"lab-complete\">\r" +
    "\n" +
    "        <i class=\"ap-message-lab-read\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"lab-incomplete\">\r" +
    "\n" +
    "        <i class=\"ap-message-lab-unread\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    \r" +
    "\n" +
    "    <span ng-switch-when=\"phone-urgent\">\r" +
    "\n" +
    "        <i class=\"ap-message-phone-important\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"phone-complete\">\r" +
    "\n" +
    "        <i class=\"ap-message-phone-read\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"phone-incomplete\">\r" +
    "\n" +
    "        <i class=\"ap-message-phone-unread\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-switch-when=\"rx-urgent\">\r" +
    "\n" +
    "        <i class=\"ap-message-rx-important\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"rx-complete\">\r" +
    "\n" +
    "        <i class=\"ap-message-rx-read\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"rx-incomplete\">\r" +
    "\n" +
    "        <i class=\"ap-message-rx-unread\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-switch-when=\"message-urgent\">\r" +
    "\n" +
    "        <i class=\"ap-message-generic-important\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"message-complete\">\r" +
    "\n" +
    "        <i class=\"ap-message-generic-read\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span ng-switch-when=\"message-incomplete\">\r" +
    "\n" +
    "        <i class=\"ap-message-generic-unread\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-switch-default>\r" +
    "\n" +
    "        <i class=\"ap-message-generic-unread\"></i>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</span>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apMessageNewNote.html',
    "<div class=\"row\" ng-if=\"vm.message.Status !== 'Complete'\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "        <div class=\"form-group\">\r" +
    "\n" +
    "            <label class=\"control-label\" translate>New Note</label>\r" +
    "\n" +
    "            <ap-select ng-if=\"vm.generalNoteTypeId\">\r" +
    "\n" +
    "                <select class=\"form-control\"\r" +
    "\n" +
    "                        name=\"NotesList\"\r" +
    "\n" +
    "                        ng-disabled=\"!vm.message.LockInfo.HaveLock\"\r" +
    "\n" +
    "                        ng-model=\"vm.selectedNote\"\r" +
    "\n" +
    "                        ng-options=\"generalNote.Notes as generalNote.Name for generalNote in vm.generalNotes\"\r" +
    "\n" +
    "                        ng-change=\"vm.selectedNoteChanged()\">\r" +
    "\n" +
    "                </select>\r" +
    "\n" +
    "            </ap-select>\r" +
    "\n" +
    "            <br ng-if=\"vm.generalNoteTypeId\" />\r" +
    "\n" +
    "            <textarea id=\"message-note\"\r" +
    "\n" +
    "                      ng-disabled=\"!vm.message.LockInfo.HaveLock\"\r" +
    "\n" +
    "                      class=\"form-control\"\r" +
    "\n" +
    "                      name=\"Note\"\r" +
    "\n" +
    "                      ng-model=\"vm.newNote\"\r" +
    "\n" +
    "                      rows=\"1\"\r" +
    "\n" +
    "                      ng-trim=\"false\"\r" +
    "\n" +
    "                      ap-auto-grow>\r" +
    "\n" +
    "            </textarea>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apMessageNotes.html',
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "        <div class=\"form-group\">\r" +
    "\n" +
    "            <label class=\"control-label\" translate>Message Notes</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\" ng-if=\"(messageNotes && messageNotes.length === 0) || (!messageNotes && !message.LatestNote)\">\r" +
    "\n" +
    "                <span translate>None</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <!-- TODO: remove when all servers return messageNotes -->\r" +
    "\n" +
    "            <div class=\"row\" ng-if=\"!messageNotes && message.LatestNote\">\r" +
    "\n" +
    "                <div class=\"col-xs-offset-1\">\r" +
    "\n" +
    "                    <span class=\"ap-label\">\r" +
    "\n" +
    "                        Most Recent Note\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <br/>\r" +
    "\n" +
    "                        <span>{{::message.LatestNote}}</span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\" ng-repeat=\"note in messageNotes | orderBy : 'note.DisplayDate' \"\r" +
    "\n" +
    "                 ng-if=\"messageNotes.length > 0\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"col-xs-offset-1\">\r" +
    "\n" +
    "                    <span class=\"ap-label\">\r" +
    "\n" +
    "                        Created by {{note.LastModifiedBy.Name}} on\r" +
    "\n" +
    "                        <ap-date-formatter data-jsdate=\"note.DisplayDate\"\r" +
    "\n" +
    "                                           data-format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <span>\r" +
    "\n" +
    "                        <br/>\r" +
    "\n" +
    "                        <span ng-bind-html=\"note.NoteAsHtml\"></span>\r" +
    "\n" +
    "                        <div class=\"row\" ng-if=\"note.InkImage\">\r" +
    "\n" +
    "                            <img ng-class=\"(isPhone || state.mode === 'locked') ? 'col-xs-12 col-md-9 col-flush' : 'col-xs-12 col-sm-9 col-md-6 col-flush'\"\r" +
    "\n" +
    "                                 ng-src=\"data:image/jpeg;base64,{{note.InkImage}}\">\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apMessageStatus.html',
    "<div class=\"col-xs-6 col-xs-flush-left\">\r" +
    "\n" +
    "    <div class=\"detail-group\">\r" +
    "\n" +
    "        <div class=\"form-group\">\r" +
    "\n" +
    "            <label class=\"control-label\" translate>Message Status</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div><span ng-bind=\"message.Status\"></span></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"col-xs-6 col-xs-flush-right\">\r" +
    "\n" +
    "    <div class=\"detail-group\">\r" +
    "\n" +
    "        <div class=\"form-group\">\r" +
    "\n" +
    "            <label class=\"control-label\" translate>Type</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div>{{message.MessageType.Name}}</div>\r" +
    "\n" +
    "            <div>{{message.MessageSubType.Name}}</div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apModalWizard.html',
    "<div ap-full-modal ap-full-modal-always>\r" +
    "\n" +
    "	<div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"$emit('modal-cancel');\">&times;</button>\r" +
    "\n" +
    "        <h4 class=\"modal-title\">{{selectedStep.title}}</h4>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "	<div class=\"modal-body\">\r" +
    "\n" +
    "		<div ng-transclude></div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "	<div class=\"modal-footer\">\r" +
    "\n" +
    "		<div ng-if=\"options.resultType === 'Patient' || options.resultType === 'DefaultProvider'\" class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-4 btn-modal-spacing\">\r" +
    "\n" +
    "                <button id=\"previous-btn\" type=\"submit\" ng-hide=\"(currentStepNumber() === 1)\" class=\"btn-modal btn-default\" wz-previous>Back</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-4\" style=\"padding: 0px\">\r" +
    "\n" +
    "                <button id=\"skip-to-review-btn\"\r" +
    "\n" +
    "                        type=\"submit\"\r" +
    "\n" +
    "                        class=\"btn-modal btn-default\"\r" +
    "\n" +
    "                        ng-click=\"closeWizard()\">\r" +
    "\n" +
    "                    Finish\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-4 btn-modal-spacing\">\r" +
    "\n" +
    "                <button id=\"next-btn\" type=\"submit\" ng-hide=\"(currentStepNumber() === getEnabledSteps().length)\" class=\"btn-modal btn-default\" wz-next>Next</button>\r" +
    "\n" +
    "                <button id=\"finish-btn\" type=\"submit\" ng-show=\"(currentStepNumber() === getEnabledSteps().length)\" class=\"btn-modal btn-default\" wz-finish>Next</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"options.resultType !== 'Patient' && options.resultType !== 'DefaultProvider'\" class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <button id=\"previous-btn\" type=\"submit\" ng-hide=\"(currentStepNumber() === 1)\" class=\"btn-modal btn-default\" wz-previous>Back</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <button id=\"next-btn\" type=\"submit\" ng-hide=\"(currentStepNumber() === getEnabledSteps().length)\" class=\"btn-modal btn-default\" wz-next>Next</button>\r" +
    "\n" +
    "                <button id=\"finish-btn\" type=\"submit\" ng-show=\"(currentStepNumber() === getEnabledSteps().length)\" class=\"btn-modal btn-default\" wz-finish>Next</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apPatientContextMenu.html',
    "<div class=\"context-menu\" id=\"patient-context-menu\" ng-cloak>\r" +
    "\n" +
    "    <ul class=\"dropdown-menu position-fixed\" role=\"menu\">\r" +
    "\n" +
    "        <li class=\"dropdown-header\">\r" +
    "\n" +
    "            <span translate>Actions</span>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id\">\r" +
    "\n" +
    "            <a ng-if=\"!isFndEnabled\"\r" +
    "\n" +
    "               class=\"pointer\"\r" +
    "\n" +
    "               role=\"menuitem\"\r" +
    "\n" +
    "               tabindex=\"1\"\r" +
    "\n" +
    "               name=\"view-patient-dashboard\"\r" +
    "\n" +
    "               data-transition-to=\"{ appRoute: 'patientDashboard', pageOpts: {sameWindow: true}, opts: {id: patient.Id}}\" translate>\r" +
    "\n" +
    "                View Patient Dashboard\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "            <fnd-configuration-dropdown-menu ng-if=\"isFndEnabled\" (navigate-callback)=\"navigateToDashboard($event)\"></fnd-configuration-dropdown-menu>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id && !hospitalRoundId\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"2\" name=\"add-external-patient\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'addExternalPatient', opts: {serviceSiteId: defaultServiceSiteId, patientId: patient.Id}}\"\r" +
    "\n" +
    "                translate>\r" +
    "\n" +
    "                Add to External Patient List\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id && hospitalRoundId\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" name=\"edit-external-patient\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'editExternalPatient', opts: {id: patient.Id, hospitalRoundId: hospitalRoundId}}\"\r" +
    "\n" +
    "                translate>\r" +
    "\n" +
    "                Edit External Patient\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <li ng-if=\"schedulePermissionAllowed\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"4\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'addAppointment', opts: {patientid: patient.Id}}\" translate>\r" +
    "\n" +
    "                Add Appointment\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"5\" name=\"start-charge-capture\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'chargeCapture', opts: chargeCaptureOptions}\" translate ap-authorization\r" +
    "\n" +
    "                provider-required=\"true\">\r" +
    "\n" +
    "                {{::'eMDs Rounds' | translate}}\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"chargeCaptureOptions.chargeCaptureId\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"6\" ng-click=\"removeChargeCapture();\">\r" +
    "\n" +
    "                <ap-spinner class=\"pull-right\" ng-show=\"removingChargeCapture\"></ap-spinner>\r" +
    "\n" +
    "                {{::'Remove eMDs Round' | translate}}\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id && hospitalRoundId && dischargeExternalPatient\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"6\" ng-click=\"dischargePatient();\">\r" +
    "\n" +
    "                <ap-spinner class=\"pull-right\" ng-show=\"dischargingPatient\"></ap-spinner>\r" +
    "\n" +
    "                {{::'Discharge Patient' | translate}}\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id && erxEnabled\">\r" +
    "\n" +
    "            <a class=\"pointer\" id=\"create-rx-context-menu\" role=\"menuitem\" tabindex=\"7\" ap-feature-check=\"\"\r" +
    "\n" +
    "                data-required-features=\"Visits_RX\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'rxwizarddrugsearch', opts : { patientId: patient.Id }}\" translate>\r" +
    "\n" +
    "                Create New Rx\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"8\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'createtaskmessage', opts: {patientid: patient.Id}}\" translate>\r" +
    "\n" +
    "                Create a Task Message\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"9\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'createportalmessage', opts: {patientid: patient.Id}}\" translate>\r" +
    "\n" +
    "                Create a Portal Message\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-if=\"patient.Id\" ap-feature-check data-required-features=\"PhoneMessageCreation\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"10\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'createphonemessage', opts: {patientid: patient.Id}}\" translate>\r" +
    "\n" +
    "                Create a Phone Message\r" +
    "\n" +
    "            </a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li class=\"divider\" ng-if=\"patient.Id && patientDashboardConfigurations && !isFndEnabled\"></li>\r" +
    "\n" +
    "        <li class=\"dropdown-header\" ng-if=\"patient.Id && patientDashboardConfigurations && !isFndEnabled\">\r" +
    "\n" +
    "            <span translate>Dashboard Configurations</span>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "        <li ng-repeat=\"configuration in dashboardConfigurations\">\r" +
    "\n" +
    "            <a class=\"pointer\" role=\"menuitem\" tabindex=\"11\" ng-if=\"patient.Id && patientDashboardConfigurations && !isFndEnabled\"\r" +
    "\n" +
    "                data-transition-to=\"{ appRoute: 'patientDashboard', pageOpts: {sameWindow: true}, opts: {id: patient.Id, config: configuration.Id}}\">\r" +
    "\n" +
    "                {{configuration.Name}}</a>\r" +
    "\n" +
    "        </li>\r" +
    "\n" +
    "    </ul>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/apPatientContextMenuModal.html',
    "<!--<div id=\"ap-patient-context-menu-modal\" ap-full-modal ap-full-modal-always>-->\r" +
    "\n" +
    "    <!--<div class=\"modal-header\">-->\r" +
    "\n" +
    "        <!--<button type=\"button\" class=\"close\" ng-click=\"$dismiss('editing')\">&times;</button>-->\r" +
    "\n" +
    "        <!--<h4 class=\"modal-title\" style=\"font-weight: bold\">Warning: Pending Charge Capture</h4>-->\r" +
    "\n" +
    "    <!--</div>-->\r" +
    "\n" +
    "    <!--<div class=\"modal-body\">-->\r" +
    "\n" +
    "        <!--<div>-->\r" +
    "\n" +
    "            <!--<ap-patient-header patient=\"patient\" mode=\"simple\"></ap-patient-header>-->\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <!--<div id=\"patient-context-menu-modal-alert\">-->\r" +
    "\n" +
    "            <!--<div class=\"row\">-->\r" +
    "\n" +
    "                <!--<div class=\"col-xs-12\" translate>-->\r" +
    "\n" +
    "                    <!--<div class=\"patient-context-menu-group\" id=\"patient-context-menu-failure\">-->\r" +
    "\n" +
    "                        <!--<span class=\"patient-context-menu-alert-header\">-->\r" +
    "\n" +
    "                            <!--{{::'Patient has an existing Charge Capture that has not yet been submitted.' | translate}}-->\r" +
    "\n" +
    "                        <!--</span>-->\r" +
    "\n" +
    "                        <!--<br>-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <!--<br>-->\r" +
    "\n" +
    "                        <!--<span>-->\r" +
    "\n" +
    "                            <!--{{::'Select \\\"Edit Charge Capture\\\" to complete the pending Charge Capture for this patient.' | translate}}-->\r" +
    "\n" +
    "                            <!--<br>-->\r" +
    "\n" +
    "                            <!--<br>-->\r" +
    "\n" +
    "                            <!--{{::'Select \\\"Force Continue\\\" to continue with the Discharge without completing the pending Charge Capture.' | translate}}-->\r" +
    "\n" +
    "                        <!--</span>-->\r" +
    "\n" +
    "                    <!--</div>-->\r" +
    "\n" +
    "                <!--</div>-->\r" +
    "\n" +
    "            <!--</div>-->\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "    <!--</div>-->\r" +
    "\n" +
    "    <!--<div class=\"modal-footer\">-->\r" +
    "\n" +
    "        <!--<div class=\"col-xs-12 col-xs-flush\">-->\r" +
    "\n" +
    "            <!--<div class=\"row\">-->\r" +
    "\n" +
    "                <!--<div class=\"col-xs-6 col-xs-flush-left\">-->\r" +
    "\n" +
    "                    <!--<button type=\"submit\" class=\"btn btn-primary btn-block\" ng-click=\"editChargeCapture()\">Edit Charge Capture</button>-->\r" +
    "\n" +
    "                <!--</div>-->\r" +
    "\n" +
    "                <!--<div class=\"col-xs-6 col-xs-flush-right\">-->\r" +
    "\n" +
    "                    <!--<button type=\"submit\" class=\"btn btn-primary btn-block\" ng-click=\"forceContinue()\">Force Continue</button>-->\r" +
    "\n" +
    "                <!--</div>-->\r" +
    "\n" +
    "            <!--</div>-->\r" +
    "\n" +
    "        <!--</div>-->\r" +
    "\n" +
    "    <!--</div>-->\r" +
    "\n" +
    "<!--</div>-->\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/apPharmacyAddress.html',
    "\r" +
    "\n" +
    "<ap-address ng-click=\"openGMap()\" data-address=\"address\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "</ap-address>"
  );


  $templateCache.put('/core-ui/views/directives/apSelect.html',
    "<!-- directive will add:\r" +
    "\n" +
    "\r" +
    "\n" +
    "<span class=\"input-group-addon open-select\"><i class=\"ap-chevron-down-gray\"></i></span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "using jquery. I tried the following:\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"input-group\" ng-transclude>\r" +
    "\n" +
    "<span class=\"input-group-addon open-select\"><i class=\"ap-chevron-down-gray\"></i></span>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "but the span was replaced with the transcluded markup.\r" +
    "\n" +
    "\r" +
    "\n" +
    "I also tried\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"input-group\">\r" +
    "\n" +
    "<span ng-transclude></span>\r" +
    "\n" +
    "<span class=\"input-group-addon open-select\"><i class=\"ap-chevron-down-gray\"></i></span>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "which also didn't work because the select was placed inside the span and thus did not match the bootstrap css rules\r" +
    "\n" +
    "and weren't styled appropriately.\r" +
    "\n" +
    "\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div ng-transclude>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/find/apFindPharmacy.html',
    "<div class=\"input-group typeahead-search-control has-feedback\">\r" +
    "\n" +
    "    <span class=\"input-group-btn\">\r" +
    "\n" +
    "        <button class=\"btn btn-default\"\r" +
    "\n" +
    "                type=\"button\"\r" +
    "\n" +
    "                ng-click=\"vm.clear()\"\r" +
    "\n" +
    "                ng-disabled=\"vm.selectDisabled()\">\r" +
    "\n" +
    "            <i class=\"fa fa-times\"></i>\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span class=\"form-control-feedback\" ng-show=\"vm.outstandingCalls\">\r" +
    "\n" +
    "        <ap-spinner size=\"1\"/>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <input\r" +
    "\n" +
    "            type=\"text\"\r" +
    "\n" +
    "            class=\"form-control find-pharmacy-search-input rounded-right\"\r" +
    "\n" +
    "            placeholder=\"{{vm.getSearchTextFromPharmacy(vm.placeHolderItem) || vm.placeholderText}}\"\r" +
    "\n" +
    "            ng-model=\"vm.selectedItem\"\r" +
    "\n" +
    "            uib-typeahead=\"pharmacy as vm.getSearchTextFromPharmacy(pharmacy) for pharmacy in vm.searchItems($viewValue)\"\r" +
    "\n" +
    "            typeahead-on-select=\"vm.itemSelected($item)\"\r" +
    "\n" +
    "            typeahead-template-url=\"/core-ui/views/directives/find/apFindPharmacyTemplate.html\"\r" +
    "\n" +
    "            ap-typeahead-track-by=\"Id\"\r" +
    "\n" +
    "            ap-typeahead-popup-classes=\"dropdown-menu-flush\"\r" +
    "\n" +
    "            ap-typeahead-default-header=\"vm.getDefaultHeader()\"\r" +
    "\n" +
    "            ap-typeahead-none-action=\"vm.callNoneAction()\"\r" +
    "\n" +
    "            ap-typeahead-display-none=\"vm.displayNone\"\r" +
    "\n" +
    "            typeahead-min-length=\"0\"\r" +
    "\n" +
    "            typeahead-wait-ms=\"300\"\r" +
    "\n" +
    "            ng-disabled=\"vm.selectDisabled()\"\r" +
    "\n" +
    "            ap-typeahead-popup-parent=\"vm.parentContainerId\"\r" +
    "\n" +
    "            ap-typeahead-popup-max-height\r" +
    "\n" +
    "            ap-autofocus=\"vm.autoFocus\"/>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/find/apFindPharmacyTemplate.html',
    "<div class=\"list-group-item\" ng-class=\"match.model.isDefault ? 'default-pharmacy' : 'searched-pharmacy'\">\r" +
    "\n" +
    "	<div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "		{{::match.model.Name}}\r" +
    "\n" +
    "		<div ap-feature-check data-required-features=\"EnhancedPharmacySearch\">\r" +
    "\n" +
    "			<div class=\"text-success\"\r" +
    "\n" +
    "				 ng-if=\"match.model.MasterPharmacy.ConfiguredForEPrescribing\">\r" +
    "\n" +
    "				<i class=\"fa fa-check\"></i>\r" +
    "\n" +
    "				{{'ERx Configured' | translate}}\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "			<div class=\"text-warning\"\r" +
    "\n" +
    "				 ng-if=\"match.model.MasterPharmacy && !match.model.MasterPharmacy.ConfiguredForEPrescribing\">\r" +
    "\n" +
    "				<i class=\"fa fa-warning\"></i>\r" +
    "\n" +
    "				{{'ERx Not Configured' | translate}}\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "			<div class=\"text-success\"\r" +
    "\n" +
    "				ng-if=\"match.model.IsMailOrder\">\r" +
    "\n" +
    "				<i class=\"ap-consumer-package-goods sigwriter-drugsearch-icon\"></i>\r" +
    "\n" +
    "					{{'Mail Order' | translate}}\r" +
    "\n" +
    "			</div>\r" +
    "\n" +
    "		</div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "	<div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "		{{::match.model.Phone.PhoneNumber}}\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "	<div class=\"list-item-details list-item-details-address overflow-ellipsis\">\r" +
    "\n" +
    "		<ap-pharmacy-address address=\"match.model.Address\"></ap-pharmacy-address>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "	<div class=\"list-item-details overflow-ellipsis\" ng-if=\"match.model.MasterPharmacy.CrossStreet\">\r" +
    "\n" +
    "		CrossStreet: {{::match.model.MasterPharmacy.CrossStreet}}\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/find/apFindPrmUser.html',
    "<div class=\"input-group typeahead-search-control has-feedback\">\r" +
    "\n" +
    "  <span class=\"input-group-btn\">\r" +
    "\n" +
    "      <button class=\"btn btn-default\"\r" +
    "\n" +
    "              type=\"button\"\r" +
    "\n" +
    "              ng-click=\"vm.clear()\"\r" +
    "\n" +
    "              ng-disabled=\"vm.selectDisabled()\">\r" +
    "\n" +
    "          <i class=\"fa fa-times\"></i>\r" +
    "\n" +
    "      </button>\r" +
    "\n" +
    "  </span>\r" +
    "\n" +
    "  <span class=\"form-control-feedback\" ng-show=\"vm.outstandingCalls\">\r" +
    "\n" +
    "      <ap-spinner size=\"1\"/>\r" +
    "\n" +
    "  </span>\r" +
    "\n" +
    "  <input\r" +
    "\n" +
    "    type=\"text\"\r" +
    "\n" +
    "    class=\"form-control patient-search-input rounded-right\"\r" +
    "\n" +
    "    placeholder=\"{{vm.getSearchTextFromFindPrmUser(vm.placeHolderItem) || vm.placeholderText}}\"\r" +
    "\n" +
    "    ng-model=\"vm.selectedItem\"\r" +
    "\n" +
    "    uib-typeahead=\"prmUser as vm.getSearchTextFromFindPrmUser(prmUser) for prmUser in vm.searchItems($viewValue)\"\r" +
    "\n" +
    "    typeahead-on-select=\"vm.itemSelected($item)\"\r" +
    "\n" +
    "    typeahead-template-url=\"/core-ui/views/directives/find/apFindPrmUserTemplate.html\"\r" +
    "\n" +
    "    ap-typeahead-track-by=\"Id\"\r" +
    "\n" +
    "    ap-typeahead-popup-classes=\"dropdown-menu-flush\"\r" +
    "\n" +
    "    typeahead-min-length=\"0\"\r" +
    "\n" +
    "    typeahead-wait-ms=\"300\"\r" +
    "\n" +
    "    ng-disabled=\"vm.selectDisabled()\"/>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/find/apFindPrmUserTemplate.html',
    "<div class=\"list-group-item\">\r" +
    "\n" +
    "  <div class=\"list-item-content\">\r" +
    "\n" +
    "    <div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "      {{::match.model.LastName}}, {{::match.model.FirstName}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "      <span translate>Type</span>: {{::match.model.Type}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"list-item-details overflow-ellipsis\" ng-if=\"!!match.model.Notes\">\r" +
    "\n" +
    "      <span>{{::match.model.Notes}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "  </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/find/apPatientSearch.html',
    "<div class=\"input-group typeahead-search-control has-feedback\">\r" +
    "\n" +
    "    <span class=\"input-group-btn\">\r" +
    "\n" +
    "        <button class=\"btn btn-default\"\r" +
    "\n" +
    "                type=\"button\"\r" +
    "\n" +
    "                ng-click=\"vm.clear()\"\r" +
    "\n" +
    "                ng-disabled=\"vm.selectDisabled()\">\r" +
    "\n" +
    "            <i class=\"fa fa-times\"></i>\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <span class=\"form-control-feedback\" ng-show=\"vm.outstandingCalls\">\r" +
    "\n" +
    "        <ap-spinner size=\"1\"/>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "    <input\r" +
    "\n" +
    "            type=\"text\"\r" +
    "\n" +
    "            class=\"form-control patient-search-input rounded-right\"\r" +
    "\n" +
    "            placeholder=\"{{vm.getSearchTextFromPatient(vm.placeHolderItem) || vm.placeholderText}}\"\r" +
    "\n" +
    "            ng-model=\"vm.selectedItem\"\r" +
    "\n" +
    "            uib-typeahead=\"patient as vm.getSearchTextFromPatient(patient) for patient in vm.searchItems($viewValue)\"\r" +
    "\n" +
    "            typeahead-on-select=\"vm.itemSelected($item)\"\r" +
    "\n" +
    "            typeahead-template-url=\"/core-ui/views/directives/find/apPatientSearchTemplate.html\"\r" +
    "\n" +
    "            ap-typeahead-track-by=\"Id\"\r" +
    "\n" +
    "            ap-typeahead-popup-classes=\"dropdown-menu-flush\"\r" +
    "\n" +
    "            typeahead-min-length=\"0\"\r" +
    "\n" +
    "            typeahead-wait-ms=\"300\"\r" +
    "\n" +
    "            ng-disabled=\"vm.selectDisabled()\"/>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/find/apPatientSearchTemplate.html',
    "<div class=\"list-group-item\">\r" +
    "\n" +
    "	<div class=\"list-item-thumbnail\">\r" +
    "\n" +
    "	    <img lazy-src=\"{{match.model.Id | apPatientThumbnailSrc:40:40}}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "	    <div class=\"status-bar-horizontal\" ng-if=\"!!match.model.Condition\"\r" +
    "\n" +
    "	         style=\"background-color: {{match.model.Condition.Color}}\">\r" +
    "\n" +
    "	    </div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "	<div class=\"list-item-content\">\r" +
    "\n" +
    "	    <div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "	        {{::match.model.FirstName}}\r" +
    "\n" +
    "	        {{::match.model.LastName}}\r" +
    "\n" +
    "	    </div>\r" +
    "\n" +
    "	    <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "	        <ap-Birthdate deathdate=\"{{match.model.DeathDate}}\"\r" +
    "\n" +
    "	                      birthdate=\"{{match.model.BirthDate}}\"/>\r" +
    "\n" +
    "	    </div>\r" +
    "\n" +
    "	    <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "	        <span translate>ID</span>: {{::match.model.ExternalId}}\r" +
    "\n" +
    "	    </div>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/multiSelectCheckBox.html',
    "<div>\r" +
    "\n" +
    "    <div ng-show=\"showAll\">\r" +
    "\n" +
    "        <input type=\"checkbox\"\r" +
    "\n" +
    "               class=\"native\"\r" +
    "\n" +
    "               id=\"all\"\r" +
    "\n" +
    "               name=\"all\"\r" +
    "\n" +
    "               ng-model=\"selectAll\">\r" +
    "\n" +
    "        <label for=\"all\" class=\"label-font\">All</label>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-repeat=\"item in list track by $index\">\r" +
    "\n" +
    "        <input type=\"checkbox\"\r" +
    "\n" +
    "               class=\"native\"\r" +
    "\n" +
    "               id=\"multi-checkbox-list-{{$index}}\"\r" +
    "\n" +
    "               ng-model=\"item.selected\">\r" +
    "\n" +
    "        <label for=\"multi-checkbox-list-{{$index}}\" class=\"label-font\">{{item.formattedDate}}</label>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/ngRepeatColumnReset.html',
    "<div class=\"clearfix\"\r" +
    "\n" +
    "     ng-class=\"(index && index%(12/xs) === 0 ? 'visible-xs-' + (display||'block') + ' ' : '') +\r" +
    "\n" +
    "                (index && index%(12/(sm||xs)) === 0 ? 'visible-sm-' + (display||'block') + ' ' : '') +\r" +
    "\n" +
    "                (index && index%(12/(md||sm||xs)) === 0 ? 'visible-md-' + (display||'block') + ' ' : '') +\r" +
    "\n" +
    "                (index && index%(12/(lg||md||sm||xs)) === 0 ? 'visible-lg-' + (display||'block') : '')\">\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/partials/apAppointmentBrief.html',
    "<div class=\"row flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "    <div class=\"pull-left\">\r" +
    "\n" +
    "        <div class=\"text-center list-item-time-large keep-whitespace-line\">\r" +
    "\n" +
    "            <span ap-date-formatter date=\"{{::$ctrl.appointment.StartDate}}\"\r" +
    "\n" +
    "                  format=\"short-day\"></span>\r" +
    "\n" +
    "            <span ap-date-formatter date=\"{{::$ctrl.appointment.StartDate}}\"\r" +
    "\n" +
    "                  format=\"short-date\"></span>\r" +
    "\n" +
    "            <span ng-if=\"::$ctrl.showDuration\">({{::$ctrl.getDuration($ctrl.appointment.StartDate) }})<br></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush-right\">\r" +
    "\n" +
    "        <div class=\"list-item-heading\">\r" +
    "\n" +
    "            {{::'Provider'| translate}} :\r" +
    "\n" +
    "            {{::$ctrl.appointment.ProviderName}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"list-item-sub-heading\">\r" +
    "\n" +
    "            {{::'Status'| translate}} :\r" +
    "\n" +
    "            {{::$ctrl.appointment.AppointmentStatus.Description}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"list-item-details\">\r" +
    "\n" +
    "            {{::'Reason'| translate}} :\r" +
    "\n" +
    "            <span style=\"color:{{::$ctrl.appointment.AppointmentType.Color}}\">{{::$ctrl.appointment.AppointmentType.Name}}</span>\r" +
    "\n" +
    "            <span ng-show=\"::$ctrl.appointment.AppointmentType.Name && $ctrl.appointment.Reason\"> - </span>\r" +
    "\n" +
    "            {{::$ctrl.appointment.Reason}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/core-ui/views/directives/partials/apAppointmentListItem.html',
    "<div class=\"appt-list-item transparency-hack\"\r" +
    "\n" +
    "     data-transition-to=\"getTransition()\"\r" +
    "\n" +
    "     hm-tap-only=\"true\"\r" +
    "\n" +
    "     ap-context-menu\r" +
    "\n" +
    "     ap-context-menu-type=\"appointment\"\r" +
    "\n" +
    "     ap-context-menu-target=\"appt-context-menu\"\r" +
    "\n" +
    "     ap-context-menu-open=\"openAppointmentContextMenu();\"\r" +
    "\n" +
    "     ap-context-menu-close=\"closeAppointmentContextMenu();\"\r" +
    "\n" +
    "     id=\"appt-{{::appt.Id}}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-col-xs text-center-vert pull-right text-center\">\r" +
    "\n" +
    "        <span><i class=\"ap-chevron-right-gray\"></i></span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-col-sm text-center-vert list-item-time pull-left text-center\">\r" +
    "\n" +
    "        <!-- date time is sent from server in calendar's time zone local time if the calendar has a timezone.\r" +
    "\n" +
    "        No need to do any shifting -->\r" +
    "\n" +
    "      <span ap-date-range-formatter\r" +
    "\n" +
    "            data-start-date=\"appt.Date\"\r" +
    "\n" +
    "            data-end-date=\"appt.EndDate\"\r" +
    "\n" +
    "            data-format=\"short-time\"\r" +
    "\n" +
    "            data-multiline=\"true\"\r" +
    "\n" +
    "            ng-if=\"displayEndTime\">\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span ap-date-formatter\r" +
    "\n" +
    "            data-date=\"{{appt.Date}}\"\r" +
    "\n" +
    "            data-format=\"short-time\"\r" +
    "\n" +
    "            ng-if=\"displayStartTime\">\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      <span class=\"keep-whitespace-line\" ng-if=\"displayDate\"><span ap-date-formatter data-date=\"{{appt.Date}}\" format=\"short-day\"></span>\r" +
    "\n" +
    "            <span ap-date-formatter data-date=\"{{appt.Date}}\" format=\"short-date\"></span>        \r" +
    "\n" +
    "       </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-thumbnail\">\r" +
    "\n" +
    "        <img ng-if=\"appt.PatientId\" lazy-src=\"{{appt.PatientId | apPatientThumbnailSrc:83:82}}\">\r" +
    "\n" +
    "        <span ng-if=\"!appt.PatientId\">\r" +
    "\n" +
    "			<i class=\"fa fa-calendar fa-5x\"></i>\r" +
    "\n" +
    "		</span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"status-bar-horizontal\"\r" +
    "\n" +
    "             style=\"background-color: {{appt.AppointmentStatus.Color}}\">\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-content\">\r" +
    "\n" +
    "        <div ng-if=\"::isPatientVisit\">\r" +
    "\n" +
    "            <div class=\"heading-title overflow-ellipsis\">\r" +
    "\n" +
    "                {{::appt.Name}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"heading-subtitle overflow-ellipsis\">\r" +
    "\n" +
    "                {{::appt.BirthDate}}\r" +
    "\n" +
    "                <span ng-if=\"appt.Age\"> | {{::appt.Age}}</span>\r" +
    "\n" +
    "                <span ng-if=\"appt.Gender\"> | {{::appt.Gender.charAt(0)}}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"::!isPatientVisit\">\r" +
    "\n" +
    "            <div class=\"heading-title overflow-ellipsis\">\r" +
    "\n" +
    "                {{::scheduleTypeDescription}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"heading-details overflow-ellipsis\">\r" +
    "\n" +
    "            <span>\r" +
    "\n" +
    "                {{appt.AppointmentType.Name || appt.AppointmentType.Description}}\r" +
    "\n" +
    "                <span ng-if=\"(appt.AppointmentType.Name || appt.AppointmentType.Description) && appt.Reason\">\r" +
    "\n" +
    "                    |\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "                {{appt.Reason}}\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"appt.Date && appt.EndDate\" class=\"heading-details overflow-ellipsis\">\r" +
    "\n" +
    "            <span ap-date-formatter jsdate=\"appt.Date\" format=\"date-time\"></span>\r" +
    "\n" +
    "            -\r" +
    "\n" +
    "            <span ap-date-formatter jsdate=\"appt.EndDate\" format=\"time\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!appt.Date || !appt.EndDate\"\r" +
    "\n" +
    "             class=\"heading-details overflow-ellipsis\">&nbsp;\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/partials/apAppointmentListTemplateSlot.html',
    "<div class=\"transparency-hack\" >\r" +
    "\n" +
    "\r" +
    "\n" +
    "	<div class=\"list-item-col-sm text-center-vert list-item-time pull-left text-center\">\r" +
    "\n" +
    "		<!-- date time is sent from server in calendar's time zone local time if the calendar has a timezone.\r" +
    "\n" +
    "		No need to do any shifting -->\r" +
    "\n" +
    "		<span ap-date-range-formatter\r" +
    "\n" +
    "			data-start-date=\"appt.Date\"\r" +
    "\n" +
    "			data-end-date=\"appt.EndDate\"\r" +
    "\n" +
    "			data-format=\"short-time\"\r" +
    "\n" +
    "			data-multiline=\"true\"\r" +
    "\n" +
    "			ng-if=\"displayEndTime\">\r" +
    "\n" +
    "		</span>\r" +
    "\n" +
    "		<span ap-date-formatter \r" +
    "\n" +
    "			data-date=\"{{appt.Date}}\"\r" +
    "\n" +
    "			data-format=\"short-time\"\r" +
    "\n" +
    "			ng-if=\"!displayEndTime\">\r" +
    "\n" +
    "		</span>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "	<div class=\"list-item-thumbnail text-center-vert\">\r" +
    "\n" +
    "		<span>\r" +
    "\n" +
    "			<i class=\"fa fa-calendar fa-5x\"></i>\r" +
    "\n" +
    "		</span>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "	<div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "		<span class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "			{{appt.AppointmentType.Name || appt.AppointmentType.Description}}\r" +
    "\n" +
    "		</span>\r" +
    "\n" +
    "	</div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/partials/apMessageListItem.html',
    "<div class=\"message-list-item transparency-hack\"\r" +
    "\n" +
    "     data-ap-transition-to-message\r" +
    "\n" +
    "     data-message-id=\"{{::$ctrl.message.Id}}\"\r" +
    "\n" +
    "     data-message-type-id=\"{{::$ctrl.message.TypeId}}\"\r" +
    "\n" +
    "     data-message-sub-type-id=\"{{::$ctrl.message.SubTypeId}}\"\r" +
    "\n" +
    "     ng-click=\"$emit('readMessage', $ctrl.message.Id);\"\r" +
    "\n" +
    "     ng-class=\"$ctrl.isRead() ? 'read' : 'unread'\"\r" +
    "\n" +
    "     id=\"message-{{::$ctrl.message.Id}}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-col-xs text-center-vert list-item-col-xs pull-right text-center\">\r" +
    "\n" +
    "        <span>\r" +
    "\n" +
    "            <i ng-class=\"::{'ap-chevron-right-gray': !$ctrl.message.IsUrgent, 'ap-important': !!$ctrl.message.IsUrgent}\"></i>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"text-center-vert text-right pull-right text-center list-item-sub-heading hidden-xs\"\r" +
    "\n" +
    "         ng-class=\"{'hidden': $ctrl.narrow || !$ctrl.message.SubType}\">\r" +
    "\n" +
    "        <span class=\"text-right overflow-ellipsis\">{{::$ctrl.message.SubType | characters:20}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-col-sm text-center-vert list-item-time pull-left text-center\">\r" +
    "\n" +
    "        <span ap-message-icon data-message=\"$ctrl.message\"></span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"status-bar-vertical\"\r" +
    "\n" +
    "         style=\"background-color: {{::$ctrl.message.UrgencyColor}}\">\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"list-item-content\">\r" +
    "\n" +
    "        <div class=\"list-item-heading overflow-ellipsis\" >\r" +
    "\n" +
    "            <span ng-if=\"::$ctrl.message.PatientName\">\r" +
    "\n" +
    "                {{::$ctrl.message.PatientName}}\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "            {{::$ctrl.message.Type}}\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-class=\"{'visible-xs': !$ctrl.narrow}\">\r" +
    "\n" +
    "                <span>{{::$ctrl.message.SubType}}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "            {{::$ctrl.message.Header}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/core-ui/views/directives/partials/apVisitBrief.html',
    "<div class=\"row flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "    <div class=\"pull-left\">\r" +
    "\n" +
    "        <div class=\"text-center list-item-time-large keep-whitespace-line\">\r" +
    "\n" +
    "            <span ap-date-formatter date=\"{{$ctrl.visit.VisitDate || $ctrl.visit.Date}}\"\r" +
    "\n" +
    "                  format=\"short-day\"></span>\r" +
    "\n" +
    "            <span ap-date-formatter date=\"{{$ctrl.visit.VisitDate || $ctrl.visit.Date}}\"\r" +
    "\n" +
    "                  format=\"short-date\"></span>\r" +
    "\n" +
    "            <span ng-if=\"::$ctrl.showDuration\">({{::$ctrl.getDuration($ctrl.visit.VisitDate || $ctrl.visit.Date) }})<br></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush-right\" ng-transclude>\r" +
    "\n" +
    "        <div class=\"list-item-heading\">\r" +
    "\n" +
    "            {{$ctrl.visit.ProviderName}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
